// ============================================================================
// GLOBAL USER SERVICE
// ============================================================================
// API calls for Global User lookup (username existence, tenant access)

import { get } from '../client/axiosClient';
import { globalUserEndpoints } from '../endpoints';
import type { GlobalUserResponse, UserTenantAccessRecord } from '../types';
import type { TenantHubApiResponse } from '../types/auth.types';

/**
 * Global User Service Class
 */
class GlobalUserService {
  /**
   * Check if a global user exists by username
   */
  async exists(username: string): Promise<TenantHubApiResponse<boolean>> {
    const response = await get<TenantHubApiResponse<boolean>>(
      globalUserEndpoints.exists(username)
    );
    return response.data;
  }

  /**
   * Get global user by username
   */
  async getByUsername(username: string): Promise<TenantHubApiResponse<GlobalUserResponse>> {
    const response = await get<TenantHubApiResponse<GlobalUserResponse>>(
      globalUserEndpoints.getByUsername(username)
    );
    return response.data;
  }

  /**
   * Get all tenant access records for a user
   */
  async getTenantAccess(userId: string): Promise<TenantHubApiResponse<UserTenantAccessRecord[]>> {
    const response = await get<TenantHubApiResponse<UserTenantAccessRecord[]>>(
      globalUserEndpoints.tenantAccess(userId)
    );
    return response.data;
  }
}

export const globalUserService = new GlobalUserService();
export default globalUserService;
